/* @flow strict */

import * as React from 'react';

type PropsType = {
  handleShowModalCreate: () => void,
  handleShowModalEdit: () => void,
  handleRemove: () => void,
  isEmptySelectedItems: boolean,
  isEmptyList: boolean,
  handleGoBack?: () => void,
  isUserList?: boolean
};

const SponsorSearchbar = ({
  handleShowModalCreate,
  handleShowModalEdit,
  handleRemove,
  isEmptySelectedItems,
  isEmptyList,
  handleGoBack,
  isUserList
}: PropsType): React.Element<'div'> => {
  return (
    <div className="container-fluid search-bar">

      <div className="s-table">
        {!!handleGoBack &&
          <div className="s-cell">
          <ul className="nav">
            <li className="actionBtn" onClick={handleGoBack}>
              <a href='#'>
                <span>Back</span>
              </a>
            </li>
          </ul>
        </div>
        }

        <div className="s-cell">
          <div className="navbar-form" style={{ float:'none', padding: '1rem 0' }} role="search">
            <div className="input-group event-search" style={{ width:'100%', display: 'none' }}>
              <input
                className="form-control"
                type="text"
                placeholder="search"
                autoComplete="off"
                disabled
              />
              <span className="input-group-btn" style={{ width:'30px' }}>
                <button className="btn btn-default btn-search" type="button">
                  <span className="icon icon-search" />
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="s-cell s-cell-buttons" style={{ width: '1%' }}>
          <ul className="nav">
            {!isEmptyList &&
              <li
                className={`actionBtn ${isEmptySelectedItems ? 'is-disabled' : ''}`}
                onClick={() => {
                  if (!isEmptySelectedItems) {
                    handleRemove();
                  }
                }}
              >
                <a href='#'><span>Remove</span></a>
              </li>
            }
            <li
              className={`actionBtn ${isEmptySelectedItems ? 'is-disabled' : ''}`}
              onClick={(): void => handleShowModalEdit()}
            >
              <a href='#'><span>Edit</span></a>
            </li>
            <li onClick={(): void => handleShowModalCreate(true)}>
              <a href='#'><span>Add {!isUserList ? 'Sponsor' : 'Users'}</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SponsorSearchbar;
